import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { updateStudentProfile } from "../../../../../store/actions/student";
import { CURRENCIES } from "../../../../../utils/constants";
import styles from "../styles.module.css";

const DisplayCurrency = ({ myDetails }) => {
    const dispatch = useDispatch();
    const [currency, setCurrency] = useState("INR");

    useEffect(() => {
        if (myDetails?.displayCurrency) {
            setCurrency(myDetails.displayCurrency);
        }
    }, [myDetails]);

    const handleSubmit = async () => {
        const payload = {
            type: "displayCurrency",
            studentId: myDetails?._id || myDetails?.id,
            currencyCode: currency,
        };

        try {
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "flex";
            const res = await dispatch(updateStudentProfile(payload));
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "none";

            if (res?.success || res?.status === 1) {
                toast.success("Display Currency Updated");
                // Update local storage if needed
                const studentData = JSON.parse(localStorage.getItem("studentData")) || {};
                if (studentData.data) {
                    studentData.data.displayCurrency = currency;
                    localStorage.setItem("studentData", JSON.stringify(studentData));
                }
            } else {
                toast.error(res?.message || "Update failed");
            }
        } catch (e) {
            console.error(e);
            if (document.getElementById("loader")) document.getElementById("loader").style.display = "none";
            toast.error("An error occurred");
        }
    };

    return (
        <div className={styles.settingsView}>
            <h3 style={{ marginBottom: '20px', color: '#fe1848' }}>Display Currency</h3>
            <p style={{ marginBottom: '20px', color: '#666', fontSize: '0.9rem' }}>
                Choose the currency in which you want to see course prices.
                Note: Payments will still be processed in INR as per platform regulations.
            </p>

            <div className={styles.formGroup} style={{ maxWidth: '400px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>Select Currency</label>
                <select
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '12px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                        fontSize: '1rem'
                    }}
                >
                    {CURRENCIES.map((curr) => (
                        <option key={curr.code} value={curr.code}>
                            {curr.code} ({curr.symbol})
                        </option>
                    ))}
                </select>
            </div>

            <div style={{ marginTop: '30px' }}>
                <button
                    onClick={handleSubmit}
                    style={{
                        padding: '12px 30px',
                        borderRadius: '8px',
                        border: 'none',
                        background: '#fe1848',
                        color: 'white',
                        fontWeight: '600',
                        cursor: 'pointer'
                    }}
                >
                    Save Preference
                </button>
            </div>
        </div>
    );
};

export default DisplayCurrency;
